export default __webpack_public_path__ + "static/media/232-pakistan.5be98f80.svg";